(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-bubble"] && !Shopify.designMode) return;
  try {
    // The count is rendered into the page by Liquid, so it is only ever as fresh as
  // the HTML that carried it. Two ways it goes stale while browsing: a page
  // restored from the back-forward cache keeps whatever the cart held at first
  // paint, and a page served from cache can predate the last add. Re-read the
  // real cart on every page show and repaint from that.
  //
  // Shopify's own cart-icon.js updates this on its cart events, but wedding bands
  // add through a plain form post rather than a Horizon component, so those
  // events never fire for them.
  (function () {
    if (window.__cartBubbleSync) return;
    window.__cartBubbleSync = true;

    function paint(count) {
      document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
        bubble.classList.toggle('visually-hidden', count === 0);
        var text = bubble.querySelector('.cart-bubble__text-count');
        if (!text) return;
        text.classList.toggle('hidden', count === 0);
        text.textContent = count > 0 && count < 100 ? String(count) : '';
      });
    }

    function sync() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { paint(cart.item_count); })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
    window.addEventListener('pageshow', function (event) { if (event.persisted) sync(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["configurator-steps"] && !Shopify.designMode) return;
  try {
    (function () {
    function initBar(bar) {
      var pill = bar.querySelector('[data-cfg-pill]');
      var track = bar.querySelector('.cfg-steps__track');
      if (!pill || !track) return;
      // When a page renders both flow bars, show only the one matching ?flow=.
      var wantDiamond = new URLSearchParams(window.location.search).get('flow') === 'diamond';
      var barDiamond = bar.getAttribute('data-cfg-flow') === 'diamond';
      if (barDiamond !== wantDiamond) { bar.style.display = 'none'; return; }
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var noAnim = bar.getAttribute('data-cfg-animate') === 'false';
      var entered = false;

      // Size + vertical placement are set instantly (no transition); only the
      // horizontal transform is animated, so the slide stays GPU-composited.
      function size(seg) {
        pill.style.width = seg.offsetWidth + 'px';
        pill.style.height = seg.offsetHeight + 'px';
        pill.style.top = seg.offsetTop + 'px';
      }
      function moveTo(x, animate) {
        if (!animate) pill.style.transition = 'none';
        pill.style.transform = 'translateX(' + x + 'px)';
        if (!animate) { pill.getBoundingClientRect(); pill.style.transition = ''; }
      }

      function update() {
        var segs = bar.querySelectorAll('.cfg-steps__seg');
        var active = bar.querySelector('.cfg-steps__seg.is-active');
        if (!active || active.offsetWidth === 0) return; // not visible yet
        size(active);
        if (!entered) {
          entered = true;
          var doAnim = !reduce && !noAnim;
          var idx = Array.prototype.indexOf.call(segs, active);
          var startX = (idx > 0 && doAnim) ? segs[idx - 1].offsetLeft : active.offsetLeft;
          moveTo(startX, false);
          requestAnimationFrame(function () { moveTo(active.offsetLeft, doAnim); });
        } else {
          moveTo(active.offsetLeft, false); // resize: snap without animating
        }
      }

      if ('ResizeObserver' in window) {
        new ResizeObserver(update).observe(track);
      } else {
        update();
        window.addEventListener('resize', update);
      }
    }

    function run() { document.querySelectorAll('.cfg-steps').forEach(initBar); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["diamond-four-cs"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-d4c]');
    if (!root) return;
    var grades = root.querySelectorAll('.d4c__grade');
    root.querySelectorAll('[data-d4c-tip]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var g = btn.closest('.d4c__grade');
        if (!g) return;
        var was = g.classList.contains('is-open');
        grades.forEach(function (x) { x.classList.remove('is-open'); });
        if (!was) { g.classList.add('is-open'); e.stopPropagation(); }
      });
    });
    document.addEventListener('click', function () { grades.forEach(function (x) { x.classList.remove('is-open'); }); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') grades.forEach(function (x) { x.classList.remove('is-open'); }); });
  })();
  } catch(e) { console.error(e); }
})();

})();
